import { ApolloGQLClient } from "client/classes/api/GQL/ApolloGQLClient";
import { ProjectStates } from "client/interfaces/ProjectStates";
import store from "src/state/store";
import { Project } from "client/classes/cms-glue/gql";
import { IListAppScenariosResponse, IAppScenario, LIST_APP_SCENARIOS, IListAppScenariosFilterVariables, GET_APP_SCENARIO, GET_APP_SCENARIO_PROJECT } from "./gql";

export default class GQLAppScenarios
{
	static async listAppScenarios(page = 0, args?: IListAppScenariosFilterVariables, signal?: AbortSignal, pageSize = 10): Promise<{scenarios: IAppScenario[], totalCount: number}>
	{
		const variables = {
			first: pageSize,
			after: (page * pageSize) - 1,
			filter: args
		};

		// viewers are limited to approved and "minor changes" scenarios
		const isViewer = store.getState().applicationModule.isViewOnlyMode;
		if(isViewer)
		{
			variables.filter ??= {};
			variables.filter.states = [ProjectStates.Approved, ProjectStates.MinorChangesRequested];
		}

		// console.log("[GQLAppScenarios] Listing app scenarios", variables);

		const data = await ApolloGQLClient.query(LIST_APP_SCENARIOS, variables, 'request to list app scenarios', signal) as IListAppScenariosResponse;

		return {scenarios: data.scenarios.nodes, totalCount: data.scenarios.totalCount};
	}

	static async getScenario(scenarioID: string, signal?: AbortSignal, args?: IListAppScenariosFilterVariables): Promise<IAppScenario>
	{
		const variables = {
			id: scenarioID,
			filter: args,
		};

		// viewers are limited to approved and "minor changes" scenarios
		const isViewer = store.getState().applicationModule.isViewOnlyMode;
		if(isViewer)
		{
			variables.filter ??= {};
			variables.filter.states = [ProjectStates.Approved, ProjectStates.MinorChangesRequested];
		}

		const data = await ApolloGQLClient.query(GET_APP_SCENARIO, variables, 'request to get app scenario', signal);
		return data.scenario as IAppScenario;
	}

	static async getScenarioProject(scenarioID: string, signal?: AbortSignal): Promise<Project>
	{
		const variables = {
			id: scenarioID
		};

		const data = await ApolloGQLClient.query(GET_APP_SCENARIO_PROJECT, variables, 'request to get app scenario project', signal);
		return data.scenario.currentRelease.projectSaveFile.project as Project;
	}
}